import React, { useState, useEffect } from "react";
import { Pencil } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useDispatch, connect, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import {
  MomentUTCDateTimeEnd,
  MomentUTCDateTimeToday,
  formatMoney,
  getDateTimeFormate,
  getFromLocalStorage,
  getUTCDate,
  setToLocalStorage,
  getConvertedAmountWithCurrency,
} from "../../sharedfiles/helper";


import Input from "../Common/inputs/Input";
import {
  AffiliateData,
  AffiliateDropdown,
  affiliateDates,
} from "../Common/data/mapData";
import {
  createAffiliate,
  getAffiliateTable,
  editAgent,
  setOpenDialog,
  getUpdateUser,
  setRecords_bcoff,
  setIsVisible_suboff,
  setResData_suboff,
  setPage_suboff,
  setItems_suboff,
  setDocsData_subaff,
  setFormData_subaff,
  setFormErrors_subaff,
  setSelected_AffiliateId,
  setCampaignList,
  setChannel,
  getAffArtwork,
  setArtworkVisible,
  setIsVisible,
  getSearchAffData,
  setIsAffChannel
} from "../Affiliate/AffiliateSlice";
import Vpagination from "../../sharedfiles/Vpagination";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Select from "../Common/inputs/SelectDropdown";
import {
  getPlayerSearchList,
  setAffiliateBtag,
  setBtagKey,
  setIsVisible as playersLoader,
  setLoader,
  setPlayerSearch
} from "../playerTable/playerSearchTableSlice";
import Skelton from "../Common/skeleton/Skeleton";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Button, buttonVariants } from "../../ui/button";
import { cn } from "../../lib/utils";
import EditUser from "../Common/Dialog/EditUser";
import { getUserDetails } from "../CreateUser/createUserSlice";
import AgentEditDialog from "./AgentEditDialog";
import { AFFILIATE_CONSTANTS, COMMON_CONSTANTS, CREATEROLE_CONSTANTS, MANUALDIALOG_CONSTANTS } from "../../sharedfiles/Constants";
import NoDataFound from "../Common/table/NoDataFound";
import { Admin, AffiliateInfo } from "../../sharedfiles/tooltipMsgs";
import Tooltips from "../Common/Tooltip";
import ArtworkPopup from "./ArtworkPopup";
import { DatePicker as Datepicker } from "../../ui/date-picker";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
const SubAffiliate = (props) => {
  const dispatch = useDispatch();
  const [error, setError] = useState([]);
  const [customBtag, setCustomBtag] = useState('');
  const [btagErr, setBtagErr] = useState(false);
  const [btagErrorMsg, setBtagErrorMsg] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [AffiliateId, setAffiliateId] = useState("");
  const [pdfBody, setPdfBody] = useState([]);
  const [searchData, setSearchData] = useState("")
  const [formdata, setFormData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    loginPin: "",
    // clientId: "",
    // btag: "",
    // role: "ADMIN",
    commissionPercentage: "",
    payoutCycle: "",
    setupCost: "",
    affiliateType: "",
  });
  const [affiliateInput, setAffiliateInput] = useState({
    payoutCycle: "",
    setupCost: "",
    commissionPercentage: "",
  });
  const [dateErr, setDateErr] = useState("")
  const [dateToErr, setDateToErr] = useState("")
  const [hasSearched, setHasSearched] = useState(false)
  const [subAffDteFields, setsubAffDteFields] = useState({
    regDateFrom: '',
    regDateTo: '',
  })
  const [agentEditError, setAgentEditError] = useState([]);
  const history = useHistory();
  const [editUserBox, setEditUserBox] = useState(false);
  const [seletedItem, setSelectedItem] = useState({});
  const [openArtwork, setOpenArtwork] = useState(false)
  const pageFirstVal = useSelector((state) => state.affiliateSlice.page_suboff);
  const pageSecondVal = useSelector(
    (state) => state.affiliateSlice.items_suboff
  );
  const recordsToShow = useSelector(
    (state) => state.affiliateSlice.records_suboff
  );
  const listAffiliate = useSelector(
    (state) => state.affiliateSlice.resData_suboff
  );
  const afiilatePay = useSelector((p) => p.dashboard.afiilatePay)

  const affGgrNgrPermission = useSelector((p) => p.dashboard.affiliate_GGR_NGR)
  const affCommissionPermission = useSelector((p) => p.dashboard.affCommission)
  const viewOnlyuser = useSelector((state) => state.dashboard.viewOnlyuser)

  const permissionToEditUserDetails = props.permissionToEditUserDetails;

  const subAffTooltip = AffiliateInfo.filter((ele, id) => id !== 9 && id !== 10 && id !== 8)

  const filedsHandler = (e, status) => {
    const { name, value } = e.target;

    // const newError = error.filter((err) => name !== err);
    // setError(newError);
    if (status == "dialog") {
      setAffiliateInput((data) => {
        return { ...data, [name]: value };
      });
      if (value === "") {
        setAgentEditError([...agentEditError, name]);
      } else {
        const isErrorsExist = agentEditError.length > 0;
        if (isErrorsExist) {
          const updated = agentEditError.filter((err) => err !== name);
          setAgentEditError(updated);
        }
      }
    }
    if (status == "input") {
      setFormData((prevState) => {
        return {
          ...prevState,
          [name]: value,
        };
      });
      dispatch(setFormData_subaff({ ...props.formData_subaff, [name]: value }));

      if (value === "") {
        setError([...error, name]);
        dispatch(setFormErrors_subaff([...props.formErrors_subaff, name]));
      } else {
        const isErrorsExist = error.length > 0;
        if (isErrorsExist) {
          const updatedErrors = error.filter((err) => err !== name);
          setError(updatedErrors);
          dispatch(setFormErrors_subaff(updatedErrors));
        }
      }
    }
  };

  const validator = () => {
    const inputValue = Object.keys(formdata);
    const err = [];
    inputValue.map((value) => formdata[value] === "" && err.push(value));
    setError(err);
    dispatch(setFormErrors_subaff(err));
    return err.length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    validator();
    if (validator()) {
      const parentAffiliateId = getFromLocalStorage("AffliateUserId");
      const demoPayload = {
        userName: formdata.userName,
        firstName: formdata.firstName,
        lastName: formdata.lastName,
        loginPin: formdata.loginPin,
        commissionPercentage: formdata.commissionPercentage,
        payoutCycle: formdata.payoutCycle,
        setupCost: formdata.setupCost,
        affiliateType: formdata.affiliateType,
        btag: customBtag.toUpperCase(),
      }
      const payload = { ...demoPayload, parentAffiliateId: parentAffiliateId };
      dispatch(createAffiliate(payload, resetButton));

      setTimeout(() => {
        const parentAffiliateId = getFromLocalStorage("AffliateUserId");
        dispatch(setIsVisible_suboff(false));
        dispatch(
          getAffiliateTable(pageFirstVal - 1, pageSecondVal, parentAffiliateId)
        );
      }, 500);
    }
  };

  const resetButton = (e) => {
    setFormData({
      userName: "",
      firstName: "",
      lastName: "",
      loginPin: "",
      // clientId: "",
      // btag: "",
      // role: "ADMIN",
      commissionPercentage: "",
      payoutCycle: "",
      setupCost: "",
      affiliateType: "",
    });
    setError([]);
    setCustomBtag('');
    setBtagErr(false);
    setAgentEditError([]);
    dispatch(setFormData_subaff({}));
    dispatch(setFormErrors_subaff([]));
  };

  useEffect(() => {
    const parentAffiliateId = getFromLocalStorage("AffliateUserId");
    const dataExist =
      Object.keys(props?.resData_suboff).length > 0 &&
      props.resData_suboff?.data?.length > 0;
    setHasSearched(true);
    if (!dataExist) {
      dispatch(setFormData_subaff(formdata));
    } else {
      const csvDataExist =
        props?.docsData_subaff &&
        Array.isArray(props.docsData_subaff) &&
        props.docsData_subaff.length > 0;
      let pdfData = [];
      if (csvDataExist) {
        pdfData = props?.docsData_subaff.slice(
          1,
          props?.docsData_subaff?.length
        );
      }
      setCsvData(props.docsData_subaff);
      setPdfBody(pdfData);

      setFormData(props.formData_subaff);
      setError(props.formErrors_subaff);
    }

    // Always (re)load the list on mount — both the very first visit and every
    // time the user navigates back to this tab (Redux data persists across
    // the component's unmount/remount, so the dataExist check above must not
    // gate this call).
    dispatch(setIsVisible_suboff(false));
    if (parentAffiliateId) {
      dispatch(
        getAffiliateTable(pageFirstVal - 1, pageSecondVal, parentAffiliateId)
      );
    } else {
      // getAffiliateTable routes its response based on whether a parentId was
      // passed — with none, it would update the main Affiliate slice instead
      // of resData_suboff/isVisible_suboff, leaving this page's loader stuck
      // forever. With no parent selected there's nothing to fetch, so just
      // clear the loading state.
      dispatch(setResData_suboff([]));
      dispatch(setIsVisible_suboff(true));
    }
  }, []);

  const handleActiveDeactive = (item, status) => {
    const data = {
      userId: item.id,
      obj: {
        firstName: item.firstName,
        lastName: item.lastName,
        // "platFormClient": "string",
        status: status,
        userName: item.userName,
      },
    };
    dispatch(getUpdateUser(data));
    const parentAffiliateId = getFromLocalStorage("AffliateUserId");

    dispatch(
      getAffiliateTable(pageFirstVal - 1, pageSecondVal, parentAffiliateId)
    );
  };

  const handleDialog = (item) => {
    setAffiliateId(item.id);
    props.dispatch(setOpenDialog(true));
    setAffiliateInput({
      payoutCycle: item.payoutCycle,
      setupCost: item.setupCostPercentage,
      commissionPercentage: item.commissionPercentage,
    });
    setAgentEditError([]);
  };

  const dialogFieldValuator = () => {
    const inputValue = Object.keys(affiliateInput);
    const err = [];

    inputValue.map((value) => affiliateInput[value] === "" && err.push(value));
    setAgentEditError(err);
    return err.length === 0;
  };

  const onSave = (e) => {
    if (dialogFieldValuator()) {
      const agentData = {
        affiliateId: AffiliateId,
        commissionPercentage: affiliateInput.commissionPercentage,
        payoutCycle: affiliateInput.payoutCycle,
        setupCost: affiliateInput.setupCost,
      };

      props.dispatch(setOpenDialog(false));
      dispatch(editAgent(agentData));
      setTimeout(() => {
        const parentAffiliateId = getFromLocalStorage("AffliateUserId");

        dispatch(
          getAffiliateTable(pageFirstVal - 1, pageSecondVal, parentAffiliateId)
        );
      }, 500);
    }
  };
  const headers = [
    [
      "ID",
      "User Name",
      "First Name",
      "Last Name",
      "Affiliate Type",
      "Btag",
      "Payout Cycle",
      "Setup Cost %",
      "Setup Cost",
      "Gross Commission",
      "Net Commission",
      "Commission %",
      "Total Registrations",
      "Deposited Customers",
      "Total Deposits",
      "New Customers",
      "Total Stakes",
      "Total Payout",
      "GGR",
      "Total Bonus Amount",
      "Total Number of Bets",
      "Total Withdrawals",
      "Created Date",
      "Updated Date",
      "URL Hits Count",
    ],
  ];
  const headersToExport = headers[0].filter((header) => {
    if (header === "Edit User") {
      return permissionToEditUserDetails;
    } else if (header === "NGR" || header === "GGR") {
      return affGgrNgrPermission;
    } else if (header === 'Setup Cost' || header === "Gross Commission" || header === "Net Commission") {
      return affCommissionPermission
    }
    else {
      return true; // Include all other headers
    }
  });
  const exportPDF = () => {
    const title = "Sub Affiliate Report";
    const styles = {
      4: {
        halign: "right",
        valign: "middle",
      },
    };

    exportPDFC(title, [headersToExport], pdfBody, styles);
  };
  useEffect(() => {
    if (Object.keys(props.resData_suboff).length > 0) {
      const data =
        props.resData_suboff &&
          props.resData_suboff?.data &&
          Array.isArray(props.resData_suboff?.data)
          ? props.resData_suboff.data.map((p) => [
            p.id,
            p.userName,
            p.firstName,
            p.lastName,
            p.affiliateTypes,
            p.btag,
            p.payoutCycle,
            p.setupCostPercentage,
            ...(affCommissionPermission ? [getConvertedAmountWithCurrency(p.setupCost, p.currencyCode || p.currency, p.baseCurrencyRate), getConvertedAmountWithCurrency(p.grossCommission, p.currencyCode || p.currency, p.baseCurrencyRate), getConvertedAmountWithCurrency(p.netCommission, p.currencyCode || p.currency, p.baseCurrencyRate)] : []),
            p.commissionPercentage,
            p.totalRegistrations,
            p.depositedUserCounts,
            getConvertedAmountWithCurrency(p.totalDeposit, p.currencyCode || p.currency, p.baseCurrencyRate),
            getConvertedAmountWithCurrency(p.totalStake, p.currencyCode || p.currency, p.baseCurrencyRate),
            getConvertedAmountWithCurrency(p.totalPayout, p.currencyCode || p.currency, p.baseCurrencyRate),
            ...(affGgrNgrPermission ? [getConvertedAmountWithCurrency(p.totalGgr, p.currencyCode || p.currency, p.baseCurrencyRate), getConvertedAmountWithCurrency(p.totalNgr, p.currencyCode || p.currency, p.baseCurrencyRate)] : []),
            p.totalBonus,
            p.betCount,
            getConvertedAmountWithCurrency(p.totalWithdraw, p.currencyCode || p.currency, p.baseCurrencyRate),
            p.firstTimeDepositedCustomers,
            p.createdDate ? getDateTimeFormate(p.createdDate) : "-",
            p.updatedDate ? getDateTimeFormate(p.updatedDate) : "-",
            p.affliateClickCount,
          ])
          : [];

      setPdfBody(data);
      const csvData =
        data && Array.isArray(data) && data.length > 0
          ? [headersToExport, ...data]
          : [headersToExport, []];
      setCsvData(csvData);
      dispatch(setDocsData_subaff(csvData));
    }
  }, [props.resData_suboff]);

  const callPageApi = (pageNumber, itemsPerPage) => {
    const parentAffiliateId = getFromLocalStorage("AffliateUserId");

    dispatch(setIsVisible_suboff(false));

    // const payload = {
    //   endDate: subAffDteFields.regDateTo !== "" ? MomentUTCDateTimeEnd(subAffDteFields.regDateTo) : '',
    //   startDate: subAffDteFields.regDateFrom !== "" ? MomentUTCDateTimeToday(subAffDteFields.regDateFrom) : "",
    //   parentAffiliateId: parentAffiliateId
    // }

    dispatch(
      getAffiliateTable(pageNumber - 1, itemsPerPage, parentAffiliateId)
    );
  };

  function navigateHandler(title, page, item) {
    // setToLocalStorage("AffliateUserId", userId);
    setToLocalStorage("SubAffUserBtag", item.btag);
    const payload = {
      affiliateBtag: item.btag,
    };
    dispatch(playersLoader(false));
    dispatch(setLoader(true));
    dispatch(setPlayerSearch([]));
    dispatch(getPlayerSearchList(0, 25, payload));
    dispatch(setSelected_AffiliateId(item.id));
    localStorage.setItem("subAffUserId", item.id)
    dispatch(setAffiliateBtag(item.btag));
    dispatch(setBtagKey(true));
    title === "CAMPAIGN" && dispatch(setCampaignList([]));
    title === "CHANNEL" && dispatch(setChannel([]));
    history.push(`/${page}`);
    dispatch(setIsAffChannel(true))
  }

  function AffNavigateHandler() {
    dispatch(setBtagKey(true));

    const btag = getFromLocalStorage("AffUserBtag")
    const payload = {
      accountStatus: "ACTIVE",
      affiliateBtag: btag,
    };
    dispatch(getPlayerSearchList(0, 25, payload));
    // dispatch(playersLoader(false));
    // dispatch(setLoader(true));
    // dispatch(setPlayerSearch([]));
    history.push('/playersearch');
  }

  const onDataSearch = value => {
    setSearchData(value)
    let data = []
    data = props.resData_suboff.data !== undefined && props.resData_suboff.data.filter((item) =>
      item.userName.includes(value)
    )
    return data;
  }

  const handleEditUser = (item) => {
    dispatch(getUserDetails(item.id));
    setAffiliateId(item.id);
    setSelectedItem(item);
    setEditUserBox((prev) => !prev);
  }

  // Header labels below are aligned 1:1 with the row cells actually
  // rendered (see subAffRowAccessors). The previous header source
  // (subAfftbHeader, imported from Common/data/mapData) labeled this
  // column "Media", but the matching row cell renders the Campaign/Channel
  // navigation buttons - fixed the caption only; no data or handler changed.
  const subAffHeaders = [
    "ID", "User Name", "First Name", "Last Name", "Affiliate Type", "Btag", "Payout Cycle", "Setup Cost %",
    ...(affCommissionPermission ? ["Setup Cost", "Gross Commission", "Net Commission"] : []),
    "Commission %", "Total Registrations", "Deposited Customers", "Total Deposits", "Total Stakes", "Total Payout",
    ...(affGgrNgrPermission ? ["GGR", "NGR"] : []),
    "Total Bonus Amount", "Total Number of Bets", "Total Withdrawals", "First Time Deposited Customer",
    "Created Date", "Updated Date", "Campaign / Channel", "Action", "URL Hits Count",
    ...(props.permissionToEditUserDetails ? ["Edit User"] : []),
  ];
  const subAffTooltips = subAffHeaders.map((_, idx) => (affCommissionPermission === false ? subAffTooltip[idx] : AffiliateInfo[idx]));
  const subAffRowAccessors = [
    (item) => item.id,
    (item) => (
      <Link
        to={{}}
        onClick={() => navigateHandler("PLAYER SEARCH", "playersearch", item)}
      >
        {item.userName}
      </Link>
    ),
    (item) => item.firstName,
    (item) => item.lastName,
    (item) => item.affiliateTypes,
    (item) => item.btag,
    (item) => item.payoutCycle,
    (item) => item.setupCostPercentage,
    ...(affCommissionPermission ? [
      (item) => getConvertedAmountWithCurrency(item.setupCost, item.currencyCode || item.currency, item.baseCurrencyRate),
      (item) => getConvertedAmountWithCurrency(item.grossCommission, item.currencyCode || item.currency, item.baseCurrencyRate),
      (item) => getConvertedAmountWithCurrency(item.netCommission, item.currencyCode || item.currency, item.baseCurrencyRate),
    ] : []),
    (item) => item.commissionPercentage,
    (item) => item.totalRegistrations,
    (item) => item.depositedUserCounts,
    (item) => getConvertedAmountWithCurrency(item.totalDeposit, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => getConvertedAmountWithCurrency(item.totalStake, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => getConvertedAmountWithCurrency(item.totalPayout, item.currencyCode || item.currency, item.baseCurrencyRate),
    ...(affGgrNgrPermission ? [
      (item) => getConvertedAmountWithCurrency(item.totalGgr, item.currencyCode || item.currency, item.baseCurrencyRate),
      (item) => getConvertedAmountWithCurrency(item.totalNgr, item.currencyCode || item.currency, item.baseCurrencyRate),
    ] : []),
    (item) => item.totalBonus,
    (item) => item.betCount,
    (item) => getConvertedAmountWithCurrency(item.totalWithdraw, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => item.firstTimeDepositedCustomers,
    (item) => (item.createdDate ? getDateTimeFormate(item.createdDate) : "-"),
    (item) => (item.updatedDate ? getDateTimeFormate(item.updatedDate) : "-"),
    (item) => (
      <>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigateHandler("CAMPAIGN", "campaign", item)}
        >
          {AFFILIATE_CONSTANTS.campaign}
        </Button>
        <div className="mb-10" bis_skin_checked="1"></div>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => navigateHandler("CHANNEL", "channel", item)}
        >
          {AFFILIATE_CONSTANTS.channel}
        </Button>
      </>
    ),
    (item) => (
      <>
        {item.accountStatus === "SUSPENDED" ? (
          <Button
            size="sm"
            onClick={() => handleActiveDeactive(item, "ACTIVE")}
          >
            <p>{COMMON_CONSTANTS.activate}</p>
          </Button>
        ) : (
          <Button
            size="sm"
            variant="destructive"
            onClick={() => handleActiveDeactive(item, "SUSPENDED")}
          >
            <p>{COMMON_CONSTANTS.Deactivate}</p>
          </Button>
        )}
        <div className="mb-10" bis_skin_checked="1"></div>
        <Button
          size="sm"
          onClick={() => handleDialog(item)}
        >
          <Pencil size={16} className="inline-block mr-2" />
          {COMMON_CONSTANTS.edit}
        </Button>
      </>
    ),
    (item) => item.affliateClickCount,
    ...(props.permissionToEditUserDetails ? [
      (item) => (
        <span
          className={cn(buttonVariants({ variant: "secondary", size: "sm" }), "cursor-pointer")}
          onClick={() => handleEditUser(item)}
          id='EditUserBtn'
        >
          {MANUALDIALOG_CONSTANTS.edit_user}
        </span>
      ),
    ] : []),
  ];
  const { visibleIndices: subAffVisibleIndices, allColumns: subAffAllColumns, toggleVisibility: subAffToggleVisibility, reorder: subAffReorder, resetToDefault: subAffResetToDefault } =
    useColumnPreferences("affiliateSubAffiliate", subAffHeaders);

  const handleArtwork = () => {
    dispatch(setArtworkVisible(true));
    setOpenArtwork(true)
    dispatch(getAffArtwork(0, 25))
  }

  function searchAllRecords() {
    dispatch(
      getAffiliateTable(
        0,
        listAffiliate.totalRecords
      )
    );
  }
  function setDateHandler(value, name) {
    setsubAffDteFields((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
    if (name === "regDateFrom") {
      if (value) setDateErr('');
    }
    if (name === "regDateTo") {
      if (value) setDateToErr('');
    }
  }

  const onSearch = () => {
    const fromMissing = !subAffDteFields.regDateFrom;
    const toMissing = !subAffDteFields.regDateTo;
    if (fromMissing) setDateErr("Start Date is required");
    else setDateErr('');
    if (toMissing) setDateToErr("End Date is required");
    else setDateToErr('');
    if (fromMissing || toMissing) return;

    const parentAffiliateId = getFromLocalStorage("AffliateUserId")
    const payload = {
      endDate: MomentUTCDateTimeEnd(subAffDteFields.regDateTo),
      startDate: MomentUTCDateTimeToday(subAffDteFields.regDateFrom),
      parentAffiliateId: parentAffiliateId
    }
    setHasSearched(true);
    dispatch(setIsVisible_suboff(false));
    dispatch(getSearchAffData(0, 25, payload));
  }

  const onResetBtn = () => {
    setsubAffDteFields({
      regDateFrom: '',
      regDateTo: ''
    })
    setDateErr('')
    setDateToErr('')
    setHasSearched(false)
    dispatch(setPage_suboff(1))
    dispatch(setItems_suboff(25))
    dispatch(setRecords_bcoff([1, 25]))
    dispatch(setIsVisible_suboff(false));
  }
  const btagHandler = (event) => {
    const { value } = event.target;
    setCustomBtag(value);
    if (/\s/.test(value)) {
      setBtagErr(true);
      setBtagErrorMsg("Spaces not allowed");
    } else if (!/^[a-zA-Z0-9]*$/.test(value)) {
      setBtagErr(true);
      setBtagErrorMsg("Btag must be Alphanumeric");
    } else if (value.length < 6 || value.length > 10) {
      setBtagErr(true);
      setBtagErrorMsg("Btag must be between 6-10 characters");
    } else {
      setBtagErr(false);
      setBtagErrorMsg("");
    }
  };

  return (
    <>
      {editUserBox && (
        <Dialog open={editUserBox} onOpenChange={setEditUserBox}>
          <DialogContent className="max-w-lg max-h-screen overflow-y-auto">
            <DialogHeader>
              <DialogTitle>Edit User Details</DialogTitle>
            </DialogHeader>
            <EditUser
              open={editUserBox}
              close={setEditUserBox}
              userId={AffiliateId}
              userDetails={seletedItem}
              rolesRequired={false}
              page={"subAffiliate"}
            />
          </DialogContent>
        </Dialog>
      )}

      <Dialog open={props.openDialog} onOpenChange={() => props.dispatch(setOpenDialog(false))}>
        <DialogContent className="max-w-lg max-h-screen overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit Agent</DialogTitle>
          </DialogHeader>
          <AgentEditDialog
            filedsHandler={filedsHandler}
            onSave={onSave}
            agentEditError={agentEditError}
            affiliateInput={affiliateInput}
          />
        </DialogContent>
      </Dialog>

      <ArtworkPopup
        openArtwork={openArtwork}
        setOpenArtwork={() => setOpenArtwork(false)}
      />

      <div className="space-y-6">
        {/* Create Sub Affiliate */}
        <div className="rounded-lg border bg-card shadow-lg">
          <div className='bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-b'>
            <h2 className='text-xl font-semibold text-gray-800 dark:text-gray-100'>Create Sub Affiliate</h2>
            <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>Create new sub-affiliate accounts with specific configurations</p>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
              <Select
                title={"Affiliate Type"}
                name={"affiliateType"}
                value={formdata.affiliateType}
                setValue={(val) => filedsHandler(val, "input")}
                options={AffiliateDropdown}
                errorMsg={
                  error.length > 0 &&
                  error.includes("affiliateType") &&
                  "select proper Affilate"
                }
                ids={"AffiliateType"}
                info={Admin.Affiliate_Type}
              />

              {AffiliateData.map((item, ind) => {
                return (
                  <React.Fragment key={item.id}>
                    <Input
                      title={item.title}
                      ids={item.ids}
                      name={item.name}
                      value={formdata[item.name]}
                      placeholder={item.placeholder}
                      setValue={(e) => filedsHandler(e, "input")}
                      regex={item.regex}
                      errorMsg={
                        error.length > 0 &&
                        error.includes(item.name) &&
                        item.errorMsg
                      }
                      info={item.info}
                      show={true}
                    />
                  </React.Fragment>
                );
              })}
              <Input
                title={"Btag"}
                name="customBtag"
                placeholder={"Enter Btag"}
                info={"Enter your own Btag or opt for system-generated Btag"}
                ids={"customBtag"}
                value={customBtag}
                setValue={btagHandler}
                maxLen={10}
                show={true}
                errorMsg={btagErr && btagErrorMsg}
              />
            </div>

            <div className="pt-6 mt-6 border-t bg-muted -mx-6 -mb-6 px-6 pb-6">
              <div className='flex justify-center gap-3'>
                <Button onClick={(e) => onSubmit(e)} id="createSubAff" disabled={viewOnlyuser}>
                  Create Sub Affiliate
                </Button>
                <Button onClick={(e) => resetButton(e)} variant="outline" id="ResetSubAff">
                  Reset
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Search Sub Affiliates & Results */}
        <div className="rounded-lg border bg-card shadow-lg">
          <div className='bg-gradient-to-r from-green-50 to-teal-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-b'>
            <h2 className='text-xl font-semibold text-gray-800 dark:text-gray-100'>Search Sub Affiliates</h2>
            <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>Filter and view sub-affiliate accounts</p>
          </div>
          <div className="p-6">
            <div className='flex flex-wrap items-start gap-4'>
              {affiliateDates.map((item, ind) => {
                const minDate = [null, subAffDteFields.regDateFrom];
                const max = subAffDteFields.regDateTo ? subAffDteFields.regDateTo : new Date();
                const maxDate = [max, new Date()];
                const values = [subAffDteFields.regDateFrom, subAffDteFields.regDateTo];
                return (
                  <React.Fragment key={ind}>
                    <div className='flex-1 min-w-[160px]'>
                      <Datepicker
                        title={item.title}
                        name={item.name}
                        value={values[ind]}
                        setValue={(date, value) => setDateHandler(date, value)}
                        errorMsg={ind === 0 ? dateErr : dateToErr}
                        minDate={minDate[ind]}
                        maxDate={maxDate[ind]}
                        ids={item.ids}
                        info={item.info}
                      />
                    </div>
                  </React.Fragment>
                );
              })}
              <div className='flex gap-2 mt-7'>
                <Button onClick={(e) => onSearch(e)} id="searchAffiliate">
                  Search
                </Button>
                <Button onClick={(e) => onResetBtn(e)} variant="outline" id="affiliateReset">
                  Reset
                </Button>
              </div>
            </div>
          </div>
          {(hasSearched || (listAffiliate?.data && listAffiliate.data.length > 0)) && (<div className='border-t'>
            <div className="p-6">
              <div className="space-y-4">
                <Vpagination
                  data={listAffiliate.data}
                  totalRecords={listAffiliate.totalRecords}
                  paginationFirstValue={pageFirstVal}
                  paginationSecondValue={pageSecondVal}
                  setPaginationFirstValue={setPage_suboff}
                  setPaginationSecondValue={setItems_suboff}
                  recordsShow={recordsToShow}
                  setRecordsShow={setRecords_bcoff}
                  isVisible={props.isVisible}
                  setIsVisible={setIsVisible_suboff}
                  csvData={csvData}
                  exportPDF={exportPDF}
                  callApi={callPageApi}
                  csvFileName={"Sub Affiliate Report"}
                  isSearch={true}
                  onDataSearch={onDataSearch}
                  focusAction={searchAllRecords}
                  placeholder={"Username or Btag"}
                  columns={subAffAllColumns}
                  onToggle={subAffToggleVisibility}
                  onReorder={subAffReorder}
                  onReset={subAffResetToDefault}
                />

                <div className='flex flex-wrap gap-3'>
                  <Button
                    variant="default"
                    onClick={() => AffNavigateHandler()}
                  >
                    View Players
                  </Button>
                  <Button
                    variant="default"
                    className="viewArtwork-btn"
                    onClick={() => handleArtwork()}
                  >
                    View Artwork Details
                  </Button>
                </div>

                {
                  !props.isVisible ?
                    <Skelton vLen={5} hLen={7} />
                    : !(props.resData_suboff?.data && Array.isArray(props.resData_suboff?.data) && props.resData_suboff?.data.length > 0) ?
                      <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
                        <p className="text-base">No Data Found</p>
                      </div>
                      :
                      <div className="rounded-md border overflow-hidden">
                        <div className="relative overflow-x-auto">
                          <Table scrollKey="affiliateSubAffiliate">
                            <TableHeader>
                              <TableRow>
                                {subAffVisibleIndices.map((origIdx) => (
                                  <TableHead key={origIdx}>
                                    <div className='flex justify-center items-center'>
                                      <p className='mx-3'>{subAffHeaders[origIdx]}</p>
                                      <Tooltips info={`${subAffTooltips[origIdx]}`} />
                                    </div>
                                  </TableHead>
                                ))}
                              </TableRow>
                            </TableHeader>
                            <TableBody>
                              {props.resData_suboff &&
                                props.resData_suboff?.data &&
                                props.resData_suboff?.data !== undefined &&
                                Array.isArray(props.resData_suboff?.data) &&
                                props.resData_suboff?.data.length > 0 ? (
                                props.resData_suboff?.data.filter((item) => item.userName.toLowerCase().replace('', '').includes(searchData.toLowerCase().replace(' ', ''))).map((item, index) => {
                                  return (
                                    <TableRow key={index}>
                                      {subAffVisibleIndices.map((origIdx) => (
                                        <TableCell key={origIdx} className='text-center whitespace-nowrap'>
                                          {subAffRowAccessors[origIdx](item)}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  );
                                })
                              ) : (
                                <NoDataFound colspan={subAffVisibleIndices.length} />
                              )}
                            </TableBody>
                          </Table>
                        </div>
                      </div>
                }
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    resData_suboff: state.affiliateSlice.resData_suboff,
    openDialog: state.affiliateSlice.openDialog,
    isVisible: state.affiliateSlice.isVisible_suboff,
    docsData_subaff: state.affiliateSlice.docsData_subaff,
    formData_subaff: state.affiliateSlice.formData_subaff,
    formErrors_subaff: state.affiliateSlice.formErrors_subaff,
    resData: state.affiliateSlice.resData,
    affiliateUsers: state.affiliateSlice.affiliateUsers,
    userRole: state.loginSlice.userRole,
    permissionToEditUserDetails: state.dashboard.permissionToEditUserDetails
  };
}

export default connect(mapStateToProps)(SubAffiliate);